/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { nodesGetApiV3Nodes } from "../../funcs/nodesGetApiV3Nodes.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3NodesRequest$inboundSchema.optional(),
};

export const tool$nodesGetApiV3Nodes: ToolDefinition<typeof args> = {
  name: "nodes-get-api-v3-nodes",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await nodesGetApiV3Nodes(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
